export class Accordion {
    constructor() {}

    addElements(elements: HTMLCollectionOf<Element>) {
        Array.from(elements).forEach((element) => {
            element.addEventListener('click', () => {
                element.classList.toggle('active');
            });
        });
    }
}
